import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import SearchPlayersIcon from '../icons/SearchPlayersIcon';
import SavedSearchesTable from '../organisms/SavedSearchesTable';
import PageContainer from './PageContainer';
import MEDIA from '../styles/media';

const useStyles = makeStyles(theme => ({
  savedSearchesPageTemplate: {
  },
  paper: {
    width: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },

  header: {
    padding: 0,
    margin: theme.spacing(5, 5, 0),
    display: 'flex',
    alignItems: 'center',
    ...theme.typography.h2,
  },
  headerIcon: {
    width: '32px',
    height: '32px',
    marginRight: theme.spacing(1),
  },

  table: {
    margin: theme.spacing(3, 5, 0),
  },

  [MEDIA.MOBILE]: {
    header: {
      margin: theme.spacing(2, 2, 0),
    },

    table: {
      margin: theme.spacing(2, 2, 0),
    },
  },
}), { name: SavedSearchesPageTemplate.name });

export default function SavedSearchesPageTemplate () {
  const classes = useStyles();

  return (
    <PageContainer className={classes.savedSearchesPageTemplate}>
      <Paper className={classes.paper}>
        <h1 className={classes.header}>
          <SearchPlayersIcon  className={classes.headerIcon} />
          Search Players
        </h1>

        <SavedSearchesTable className={classes.table} />
      </Paper>
    </PageContainer>
  );
}
